export interface Movie {
  id: string;
  title: string;
  englishTitle: string;
  slug: string;
  category: string;
  year: number;
  rating: number;
  poster: string;
  description: string;
  tags: string[];
  quality: string;
  region: string;
  duration: string;
  updateTime: string;
  views: number;
  featured: boolean;
}

export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-mic-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-emotion-laugh-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-film-line' },
  { slug: 'duanju', name: '短剧', icon: 'ri-smartphone-line' },
  { slug: 'dongzuo', name: '动作片', icon: 'ri-run-line' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-happy-line' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth III',
    slug: 'liulang-diqiu-3',
    category: 'kehuan',
    year: 2026,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%20with%20astronaut%20and%20spaceship%20in%20dramatic%20cinematic%20lighting%2C%20dark%20atmosphere%2C%20epic%20scale%2C%20professional%20movie%20poster%20design%2C%20minimal%20clean%20background%20with%20deep%20space%20vibe&width=600&height=800&seq=movie-poster-01&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的星际流浪之旅。第三部延续前作宏大叙事，展现人类在危机面前的勇气与智慧。',
    tags: ['科幻', '灾难', '冒险', '国产'],
    quality: '4K',
    region: '中国大陆',
    duration: '148分钟',
    updateTime: '2026-08-04',
    views: 1580000,
    featured: true,
  },
  {
    id: '2',
    title: '封神第二部',
    englishTitle: 'Creation of the Gods II',
    slug: 'fengshen-di-er-bu',
    category: 'dongzuo',
    year: 2025,
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20epic%20cinematic%20composition%2C%20golden%20and%20crimson%20color%20palette%2C%20professional%20movie%20poster%20design%2C%20dramatic%20lighting%20on%20simple%20dark%20background&width=600&height=800&seq=movie-poster-02&orientation=portrait',
    description: '姜子牙携封神榜归来，西岐与朝歌之战一触即发。姬发面对殷寿的强大压迫，必须找到内心的力量，带领西岐子民反抗暴政。',
    tags: ['奇幻', '动作', '神话', '国产'],
    quality: '4K',
    region: '中国大陆',
    duration: '156分钟',
    updateTime: '2026-08-03',
    views: 2340000,
    featured: true,
  },
  {
    id: '3',
    title: '奥本海默',
    englishTitle: 'Oppenheimer',
    slug: 'aoben-haimo',
    category: 'dianying',
    year: 2023,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Hollywood%20biographical%20drama%20movie%20poster%20with%20intense%20portrait%20of%20scientist%2C%20nuclear%20explosion%20symbolism%2C%20dark%20and%20brooding%20atmosphere%2C%20professional%20cinematic%20poster%20design%2C%20clean%20simple%20background&width=600&height=800&seq=movie-poster-03&orientation=portrait',
    description: '克里斯托弗·诺兰执导的传记惊悚片，讲述了理论物理学家罗伯特·奥本海默在曼哈顿计划中的关键角色，以及他作为"原子弹之父"所面临的道德困境。',
    tags: ['传记', '历史', '剧情', '好莱坞'],
    quality: '蓝光',
    region: '美国',
    duration: '180分钟',
    updateTime: '2026-08-02',
    views: 890000,
    featured: true,
  },
  {
    id: '4',
    title: '沙丘2',
    englishTitle: 'Dune: Part Two',
    slug: 'shaqiu-2',
    category: 'kehuan',
    year: 2024,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20desert%20landscape%20and%20mysterious%20figures%2C%20warm%20golden%20sand%20tones%2C%20cinematic%20wide%20shot%2C%20professional%20movie%20poster%20design%2C%20minimal%20clean%20background&width=600&height=800&seq=movie-poster-04&orientation=portrait',
    description: '保罗·厄崔迪与弗雷曼人联合，向摧毁他家庭的阴谋者展开复仇。面对一生挚爱与已知宇宙命运之间的抉择，他必须努力阻止只有他能预见的可怕未来。',
    tags: ['科幻', '冒险', '动作', '好莱坞'],
    quality: '4K',
    region: '美国',
    duration: '166分钟',
    updateTime: '2026-08-01',
    views: 1200000,
    featured: false,
  },
  {
    id: '5',
    title: '繁花',
    englishTitle: 'Blossoms Shanghai',
    slug: 'fanhua',
    category: 'dianshiju',
    year: 2024,
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%20set%20in%201990s%20Shanghai%2C%20nostalgic%20warm%20tones%2C%20elegant%20fashion%2C%20vintage%20vibe%2C%20professional%20drama%20poster%20design%2C%20clean%20simple%20background&width=600&height=800&seq=movie-poster-05&orientation=portrait',
    description: '九十年代的上海，阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上，人人争做人上人，一段传奇故事就此展开。',
    tags: ['剧情', '年代', '商战', '国产'],
    quality: '4K',
    region: '中国大陆',
    duration: '30集',
    updateTime: '2026-08-04',
    views: 3200000,
    featured: true,
  },
  {
    id: '6',
    title: '庆余年第二季',
    englishTitle: 'Joy of Life Season 2',
    slug: 'qingyunian-di-er-ji',
    category: 'dianshiju',
    year: 2024,
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20TV%20series%20poster%20with%20ancient%20Chinese%20costume%2C%20elegant%20warrior%20figure%2C%20dramatic%20cinematic%20composition%2C%20professional%20drama%20poster%20design%2C%20dark%20mysterious%20simple%20background&width=600&height=800&seq=movie-poster-06&orientation=portrait',
    description: '范闲在经历了生死考验后，回到京都开始了新一轮的权谋布局。第二季悬念升级，范闲的身世之谜逐步揭开，各方势力暗流涌动。',
    tags: ['古装', '权谋', '喜剧', '国产'],
    quality: '4K',
    region: '中国大陆',
    duration: '36集',
    updateTime: '2026-08-03',
    views: 2800000,
    featured: false,
  },
  {
    id: '7',
    title: '王牌对王牌第九季',
    englishTitle: 'Trump Card Season 9',
    slug: 'wangpai-dui-wangpai-9',
    category: 'zongyi',
    year: 2026,
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20colorful%20playful%20game%20show%20aesthetic%2C%20celebrities%20silhouette%2C%20bright%20festive%20atmosphere%2C%20professional%20TV%20show%20poster%20design%2C%20clean%20simple%20background&width=600&height=800&seq=movie-poster-07&orientation=portrait',
    description: '经典室内竞技真人秀重磅回归！新一季王牌家族与嘉宾展开趣味游戏对决，欢笑不断，温情满满，带给观众最纯粹的快乐。',
    tags: ['综艺', '搞笑', '竞技', '国产'],
    quality: '1080P',
    region: '中国大陆',
    duration: '12期',
    updateTime: '2026-08-01',
    views: 1900000,
    featured: false,
  },
  {
    id: '8',
    title: '铃芽之旅',
    englishTitle: 'Suzume',
    slug: 'lingya-zhi-lv',
    category: 'dongman',
    year: 2023,
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20with%20beautiful%20scenery%20and%20young%20girl%20protagonist%2C%20soft%20dreamy%20color%20palette%2C%20emotional%20cinematic%20anime%20style%2C%20professional%20movie%20poster%20design%2C%20clean%20simple%20background&width=600&height=800&seq=movie-poster-08&orientation=portrait',
    description: '生活在九州乡间的17岁少女铃芽，遇到了一名正在寻找"门"的神秘青年。两人共同踏上了关闭灾难之门、拯救日本的冒险旅程。',
    tags: ['动画', '奇幻', '冒险', '日本'],
    quality: '蓝光',
    region: '日本',
    duration: '122分钟',
    updateTime: '2026-08-04',
    views: 760000,
    featured: false,
  },
  {
    id: '9',
    title: '地球脉动第三季',
    englishTitle: 'Planet Earth III',
    slug: 'diqiu-maidong-3',
    category: 'jilupian',
    year: 2023,
    rating: 9.7,
    poster: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20wildlife%20photography%2C%20vibrant%20natural%20colors%2C%20animal%20in%20its%20habitat%2C%20professional%20documentary%20poster%20design%2C%20clean%20natural%20background&width=600&height=800&seq=movie-poster-09&orientation=portrait',
    description: 'BBC史诗级自然纪录片系列回归！采用最先进的拍摄技术，从海洋深处到最高的山峰，探访地球上最后的荒野之地，记录野生动物的生存故事。',
    tags: ['纪录片', '自然', 'BBC', '英国'],
    quality: '4K',
    region: '英国',
    duration: '8集',
    updateTime: '2026-08-02',
    views: 650000,
    featured: false,
  },
  {
    id: '10',
    title: '年会不能停',
    englishTitle: 'Johnny Keep Walking!',
    slug: 'nianhui-buneng-ting',
    category: 'xiju',
    year: 2023,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20office%20workers%20in%20humorous%20situation%2C%20bright%20playful%20visual%20style%2C%20corporate%20satire%20theme%2C%20professional%20movie%20poster%20design%2C%20clean%20simple%20background&width=600&height=800&seq=movie-poster-10&orientation=portrait',
    description: '钳工胡建林阴差阳错被调入集团总部，与人事经理马杰和外包员工潘怡然一起，揭露了大厂裁员背后的黑幕，笑料不断中呈现职场众生相。',
    tags: ['喜剧', '职场', '国产'],
    quality: '4K',
    region: '中国大陆',
    duration: '130分钟',
    updateTime: '2026-08-04',
    views: 2100000,
    featured: false,
  },
  {
    id: '11',
    title: '你想活出怎样的人生',
    englishTitle: 'The Boy and the Heron',
    slug: 'ni-xiang-huochu-zenyang-de-rensheng',
    category: 'dongman',
    year: 2023,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20anime%20movie%20poster%20with%20boy%20and%20mysterious%20heron%20bird%2C%20fantasy%20whimsical%20atmosphere%2C%20hand-drawn%20animation%20style%2C%20professional%20movie%20poster%20design%2C%20soft%20dreamy%20background&width=600&height=800&seq=movie-poster-11&orientation=portrait',
    description: '宫崎骏最新力作！少年牧真人在母亲去世后，跟随一只会说话的苍鹭进入神秘塔楼，开启了一段奇幻冒险，探寻生命与成长的深刻意义。',
    tags: ['动画', '奇幻', '成长', '日本'],
    quality: '蓝光',
    region: '日本',
    duration: '124分钟',
    updateTime: '2026-08-02',
    views: 920000,
    featured: false,
  },
  {
    id: '12',
    title: '飞驰人生2',
    englishTitle: 'Pegasus 2',
    slug: 'feichi-rensheng-2',
    category: 'xiju',
    year: 2024,
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20race%20car%20and%20team%2C%20dynamic%20action-packed%20vibe%2C%20warm%20humorous%20tone%2C%20professional%20movie%20poster%20design%2C%20clean%20simple%20background&width=600&height=800&seq=movie-poster-12&orientation=portrait',
    description: '曾经的赛车冠军张驰沦为驾校教练，濒临破产之际接到一个天降大单——赞助商要求他组建车队重返赛场，一群不靠谱的伙伴再度集结。',
    tags: ['喜剧', '赛车', '运动', '国产'],
    quality: '4K',
    region: '中国大陆',
    duration: '129分钟',
    updateTime: '2026-08-01',
    views: 1750000,
    featured: false,
  },
];